import { GoInfo } from 'react-icons/go';
import { searchContext } from '../../../../context/Context';
import { ButtonInfoGeneContentProps } from '../../types';

export function ButtonInfoGeneContent({ value }: ButtonInfoGeneContentProps) {
  const { setGeneContent } = searchContext();

  const handleClick = () => {
    setGeneContent({ isActive: false, geneInfo: null });
    setTimeout(() => {
      setGeneContent({ isActive: true, geneInfo: value });
    }, 0);
  };

  return (
    <button
      type="button"
      className="btn btn-link p-0 ms-1"
      onClick={handleClick}
      style={{ fontSize: '0.8em', color: '#007bff', cursor: 'pointer' }}
      title="Show gene information"
    >
      <GoInfo className="w-5 h-4 stroke-1 text-blue m-1" />
    </button>
  );
}